const reviveId = '727bec5e09208690b050ccfc6a45d384'

export const reviveAdData = {
  addTop: {
    zoneId: '23925', // zoneId: '23912',
    reviveId,
    dimension: [728, 90]
  },
  addRight: {
    zoneId: '23924', // zoneId: '23913',
    reviveId,
    dimension: [300, 600]
  },
  addLeft: {
    zoneId: '23923', // zoneId: '23914',
    reviveId,
    dimension: [300, 250]
  },
  mobSm: {
    zoneId: '23926', // zoneId: '23890',
    reviveId,
    dimension: [320, 50]
  },
  addBottom: {
    zoneId: '23928', // zoneId: '23912',
    reviveId,
    dimension: [728, 90]
  },
  add300: {
    zoneId: '24280', // zoneId: '24279',
    reviveId,
    dimension: [300, 300]
  }
}
